import { render, staticRenderFns } from "./SearchCompany.vue?vue&type=template&id=1a6538fb&scoped=true"
import script from "./SearchCompany.vue?vue&type=script&lang=js"
export * from "./SearchCompany.vue?vue&type=script&lang=js"
import style0 from "./SearchCompany.vue?vue&type=style&index=0&id=1a6538fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6538fb",
  null
  
)

export default component.exports